import {
  assetHasAutomaticTicker,
  EAssetAutomationLevel,
  EAssetSource,
  type IAsset,
  type ICommodityQuote,
  type ICompanyProfile,
  type ICryptoQuote,
  type IntegrationProvider,
} from 'findef';
import { prettyAssetSource } from '.';

export const getMaintainedText = (asset: IAsset, provider?: IntegrationProvider) => {
  if (asset.source === EAssetSource.IR) return 'I. Relations';
  if (asset.providerImport) return 'Provider';
  if (asset.companyProfile && typeof asset.companyProfile === 'object') {
    const companyProfile = asset.companyProfile as ICompanyProfile;
    if (companyProfile.manuallyAdded || companyProfile.isActivelyTrading !== true) return 'Manual';
    return 'Ticker';
  }
  if (asset.commodityQuote && typeof asset.commodityQuote === 'object') {
    const commodity = asset.commodityQuote as ICommodityQuote;
    if (commodity.manuallyAdded) return 'Manual';
    return 'Ticker';
  }
  if (asset.cryptoQuote && typeof asset.cryptoQuote === 'object') {
    const crypto = asset.cryptoQuote as ICryptoQuote;
    if (crypto.manuallyAdded) return 'Manual';
    return 'Ticker';
  }
  if (assetHasAutomaticTicker(asset) && asset.automation !== EAssetAutomationLevel.MANUAL) {
    return provider ? 'Provider' : 'Ticker';
  }
  if (provider) {
    return 'Provider';
  }

  return prettyAssetSource(asset.source || EAssetSource.MANUAL);
};
